import { render, staticRenderFns } from "./classSelection.vue?vue&type=template&id=88e2511a&scoped=true&"
import script from "./classSelection.vue?vue&type=script&lang=js&"
export * from "./classSelection.vue?vue&type=script&lang=js&"
import style0 from "./classSelection.vue?vue&type=style&index=0&id=88e2511a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e2511a",
  null
  
)

export default component.exports